import { Typography } from '@material-ui/core'

const ResolutionTitle = ({ record }) => (
  <Typography variant="body2">
    {' '}
    <b>
      {record.numero} {record.libelle}
    </b>{' '}
    - Majorité {record.majorite_bo} - {record.repartition_libelle}
  </Typography>
)
export default ResolutionTitle
